module.exports = __webpack_public_path__ + "img/logo.c67ddd7a.png";